<template>
	<div id="login">
		<h1>登录并注册</h1>
		<p class="input_box">
			<span class="dasai ds_yonghu"></span>
			<input type="number" maxlength="11" placeholder="请输入手机号" v-model="Mobile">
		</p>
		<p class="input_box">
			<span class="dasai ds_ziyuanxhdpi"></span>
			<input type="number" maxlength="6" placeholder="请输入验证码" v-model="code">
			<button id="getcode" @click="checkPhone()" class="code" v-text="getcodetext"></button>
		</p>

		<mt-button  :disabled='disabled' type="primary" style='width: 80%;margin-top: 50px;' @click='bindSuccess()'>登录</mt-button>
	</div>
</template>

<script>
	import { Toast } from 'mint-ui';
	export default {
		data() {
			return {
				Mobile: '',
				code:'',
				getcodetext: "获取验证码",
				countdown: 60,
				disabled:false
			}
		},
		created(){
			
			
		},
		beforeCreate(){
			var competition_cookie = localStorage.getItem("competition_cookie")
			var competition_info = localStorage.getItem("competition_info")
			console.log(competition_cookie&&competition_info)
			if(competition_cookie&&competition_info){
				this.$router.go(-1);
			}
		},
		methods: {
			bindSuccess(){
				this.disabled = true
				this.$http.post('/api/Token', {
					Mobile:this.Mobile,
					Code:this.code
				})
				.then(res => {
						console.log(res)
						if(res.data.Success){
							this.settime();
							Toast({
							  message: '登录成功',
							  position: 'bottom',
							  duration: 3000
							});
							
							localStorage.setItem('competition_cookie',res.data.data.token)
							localStorage.setItem('competition_info',JSON.stringify(res.data.data))
							
							window.history.go(0)
							// this.$router.go(-1);
						}else{
							Toast({
							  message: res.data.ErrorMsg,
							  position: 'bottom',
							  duration: 3000
							});
							this.disabled = false
						}
				})
				.catch(error => {
				  console.log(error)
				})
			},
			checkPhone() {
				this.$http.post('/api/SendCode', {
						Mobile: this.Mobile
					})
					.then(res => {
						console.log(res)
						if (res.data.Success) {
							this.settime();
							Toast({
							  message: '短信发送成功！',
							  position: 'bottom',
							  duration: 3000
							});
						} else {
							Toast({
							  message: res.data.ErrorMsg,
							  position: 'bottom',
							  duration: 3000
							});
						}
					})
					.catch(error => {
						console.log(error)
					})
			},
			settime() {
				if (this.countdown == 0) {
					document.getElementById("getcode").removeAttribute("disabled");
					this.getcodetext = "获取验证码";
					this.countdown = 60;
				} else {
					document.getElementById("getcode").setAttribute("disabled", true);
					this.getcodetext = "重新发送(" + this.countdown + ")";
					this.countdown--;
					var that = this;
					setTimeout(function() {
						that.settime()
					}, 1000)
				}
			
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	#login {
		text-align: center;

		h1 {
			text-align: center;
			font-size: 1.2rem;
			margin: 4rem 0 3rem 0;
		}

		.input_box {
			border: 1px solid #999;
			width: 80%;
			margin: 20px auto;
			height: 2.5rem;
			line-height: 2.5rem;
			border-radius: 4px;
			display: flex;
			align-items: center;
			overflow: hidden;

			.dasai {
				padding: 0 10px;
			}

			.code {
				display: block;
				background: #3E1976;
				color: #fff;
				height: 2.5rem;
				line-height: 2.5rem;
				white-space: nowrap;
				padding: 0 10px;
				box-sizing: border-box;
				width: 5.5rem;
				text-align: center;
				border: none
			}

			input {
				flex: 1;
				width: 130px;
				line-height: 2.5rem;
				font-size: 1rem;
				padding-right: 10px;
				border: none
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue